import type { LibraryDeps } from '../library/LibraryDeps'

/**
 * OnlyFans' own /api2/v2 calls through the CRM gateway's pass-through
 * (/v1/of/raw), made exactly as the OnlyFans page makes them (contract:
 * docs/of_home_queue_profile_capture_2026-10-08/SPEC.md).
 */
export type QueryValue = string | number | boolean | null | undefined | readonly (string | number)[]

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export interface OfApi {
  get: <T = unknown>(path: string, query: Record<string, QueryValue>, referer: string) => Promise<T>
  send: <T = unknown>(method: Exclude<HttpMethod, 'GET'>, path: string, referer: string, body?: unknown, query?: Record<string, QueryValue>) => Promise<T>
}

/** `a[]=1&a[]=2` style query, keys in the given order, empty values left out. */
export function queryString(query: Record<string, QueryValue>): string {
  const parts: string[] = []
  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined || value === '') continue
    const values = Array.isArray(value) ? value : [value]
    for (const v of values) parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`)
  }
  return parts.join('&')
}

export function apiPath(path: string, query: Record<string, QueryValue> = {}): string {
  const qs = queryString(query)
  return `/api2/v2/${path.replace(/^\/+/, '')}${qs ? `?${qs}` : ''}`
}

export function createOfApi(gateway: LibraryDeps['gateway']): OfApi {
  return {
    get: (path, query, referer) => gateway('/v1/of/raw', { method: 'GET', api_path: apiPath(path, query), referer, body: null }),
    send: (method, path, referer, body, query) =>
      gateway('/v1/of/raw', { method, api_path: apiPath(path, query), referer, body: body === undefined ? null : body }),
  }
}

export const OF = 'https://onlyfans.com'
